module.exports = __webpack_public_path__ + "static/littleWomen6-5d58f3362711a1db8f90822e285dc7b5.jpg";